import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class ArianMenuService {
  public event = null;
  public refresh = null;
  public arianMenuChanged = new EventEmitter();
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/layout/directives/arian-menu.service.ts